import { MeetingRoomDl } from "../../model/meetingRoomDl";
import { asSelectOptions, SelectOptionsType } from "../../utils/select-helpers";

import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = MeetingRoomDl;

type fetchResponseType = {
  data?: DtoType[];
  error?: string;
};

export type GuiResponseType = {
  data?: SelectOptionsType[];
  error?: string;
};

export async function getMeetingRoomDls(): Promise<GuiResponseType> {
  try {
    const response: fetchResponseType = await fetchGetJSON(
      apiUrls.getMeetingRoomDls
    );
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      const xResponseData = asSelectOptions({ data: response.data });
      return { data: xResponseData };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error getMeetingRoomsDl:", err);
    return { error: (err as Error).message };
  }
}
